export const exportHeaders = [
    {
        label: "Product Code",
        key: "product_code"
    },
    {
        label: "Product Short Description",
        key: "product_short_description",
    },
    {
        label: "Product Primary Class Id",
        key: "product_primary_class_id",
    },
    {
        label: "Product Brand Name Code",
        key: "product_brand_name_code",
    },
    {
        label: "Label Class Code",
        key: "label_class_code",
    },
    {
        label: "Dental Product Full Display Description",
        key: "dental_product_full_display_description",
    },
    {
        label: "Primary Major Class Code",
        key: "primary_major_class_code",
    },
    {
        label: "Primary Major Class Description",
        key: "primary_major_class_description",
    },
    {
        label: "Primary Major Sub Major Class Code",
        key: "primary_majorsubmajor_class_code"
    },
    {
        label: "Primary Major Sub Major Class Description",
        key: "primary_majorsubmajor_class_description"
    },
    {
        label: "Load Date",
        key: "load_date"
    },
    {
        label: "Status",
        key: "is_active"
    }
]